import baseService from "../services/BaseService";

export const addOrders = async (userId, values) =>
  baseService.post(`order/${userId}`, values);
export const getUserOrder = async (userId) =>
  baseService.get(`order/webuser/${userId}`);
export const getOrdersById = async (id) => baseService.get(`order/` + id);
